import Image from 'app/Components/Shared/Image/image';
import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux';
import { checkLoginData } from 'app/Components/Page/SelfCarePage/Utilities';
import { prepareSameWindowUrlWithNavigateTo } from 'app/utilities/StringHelpers/StringHelpers';
import { renderAuthButtons, text } from '../../constants';
import Config from '../../../../../Config';
import EpiContext from '@episerver/spa-core/Spa';
const SelfCareMenu = (props) => {
    const { showSelfCareMenu, setShowSelfCareMenu, context, toggleVisibility, headerData: { animate, selfCareData } } = props;
    const { isFullAuthenticated, isOtpAuthenticated, isOtpExtendedAuthenticated, isSilentOtpAuthenticated, userDetails } = props?.authentication?.loginData;

    const isUserConnected = checkLoginData(props.authentication.loginData);

    const getUserName = () => {
        if (isUserConnected) {
            if (isOtpAuthenticated || isOtpExtendedAuthenticated) {
                if (userDetails?.firstName && userDetails?.lastName)
                    return userDetails?.firstName;
                else return userDetails?.contactNumber;
            }
            else if (isFullAuthenticated)
                return userDetails?.firstName;
        }
        return 'איזור אישי';
    }

    const handleItemClick = (item) => {
        setShowSelfCareMenu(false)
        prepareSameWindowUrlWithNavigateTo(item?.link?.value, context);
    };

    const purpleArrowSvg = require('../../images/left-svg-purple.svg');
    const authButtons = renderAuthButtons(Config, props, prepareSameWindowUrlWithNavigateTo, isUserConnected, setShowSelfCareMenu, purpleArrowSvg);

    return (
        <>
            <div className="sc-img-container">
                <div className={`user-name-container ${!isUserConnected ? 'not-connected' : ''}`} onClick={() => isUserConnected ? toggleVisibility() : EpiContext.navigateTo(Config.newLoginUrl)}>
                    <span className={`user-name ${props.isBusiness ? 'business' : ''}`}>{getUserName()}</span>
                    {isUserConnected && (
                        <Image className="arrow-icon" src={require('../../images/down.svg')} />
                    )}
                </div>
            </div>

            {showSelfCareMenu && isUserConnected && <div className={`self-care-area-box ${animate}`}>
                <div className="self-care-items-purple">
                    {authButtons}
                    {selfCareData !== null && selfCareData?.purpleButtons?.value !== null && (
                        <>
                            {
                                selfCareData?.purpleButtons?.expandedValue.map((item, i) => (
                                    <div
                                        key={i}
                                        className="item-purple self-care-item"
                                        onClick={() =>
                                            handleItemClick(item)
                                        }>
                                        <span>{item?.text?.value}</span>
                                        <Image src={purpleArrowSvg} />
                                    </div>
                                ))
                            }
                        </>
                    )}
                </div>
                {authButtons && (
                    <div className="self-care-area-seperator"></div>
                )}
                {selfCareData !== null && selfCareData?.regularButtons?.value !== null && (
                    <div className="self-care-items-regular">
                        {selfCareData?.regularButtons?.expandedValue.map((item, i) => (
                            item.isLinkForContactManager.value ?
                                props.authentication.loginData.userDetails.IsContactPerson && isUserConnected &&
                                <div
                                    key={i}
                                    onClick={() => handleItemClick(item)}
                                    className={`${i === selfCareData?.regularButtons?.expandedValue?.length - 1 ? 'last' : ''} item-regular self-care-item`}
                                >
                                    <span>{item?.text?.value}</span>
                                    <Image src={require('../../images/left.svg')} />
                                </div>
                                :
                                item.isLinkForPrivateClient.value ?
                                    !props.authentication.loginData.userDetails.IsContactPerson && isUserConnected &&
                                    <div
                                        key={i}
                                        onClick={() => handleItemClick(item)}
                                        className={`${i === selfCareData?.regularButtons?.expandedValue?.length - 1 ? 'last' : ''} item-regular self-care-item`}
                                    >
                                        <span>{item?.text?.value}</span>
                                        <Image src={require('../../images/left.svg')} />
                                    </div>
                                    :
                                    <div
                                        key={i}
                                        onClick={() => handleItemClick(item)}
                                        className={`${i === selfCareData?.regularButtons?.expandedValue?.length - 1 ? 'last' : ''} item-regular self-care-item`}
                                    >
                                        <span>{item?.text?.value}</span>
                                        <Image src={require('../../images/left.svg')} />
                                    </div>
                        )
                        )}
                    </div>
                )}
                {(isUserConnected) && (
                    <div
                        className="self-care-disconnect"
                        onClick={() => prepareSameWindowUrlWithNavigateTo(Config.logoutPage, context)}
                    >
                        <span className="img-location">התנתקות</span>
                        <span>
                            <Image src={require('../../images/log_out_desktop.svg')} />
                        </span>
                    </div>
                )}
            </div>}</>
    );
}


const mapStateToProps = (state) => {
    return {
        headerData: state.Header,
        authentication: state.authentication
    };
};
const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(SelfCareMenu);
